import {
  IAuthActionTypes,
  IAuthActionCreator,
  IAuthState,
} from "models/IAuthState";

const normalizeAccessLevel = (info: any) => ({
  ...(info || {}),
  access_level: info && info.access_level ? info.access_level : "user",
});

const initialState: IAuthState = {
  isotpverified: false,
  isotpreceived: false,
  otperrormessage: "",
  authtoken: localStorage.getItem("auth_token"),
  verifytoken: "",
  isuserLogin: !!localStorage.getItem("auth_token"),
  currentuserinfo: {},
  isFRVerified: false,
  is_fr_verification_in_progress: false,
  is_in_api_call: false,
};

const reducer = (
  state = initialState,
  { type, payload }: IAuthActionCreator
) => {
  switch (type) {
    case IAuthActionTypes.OTP_REQUEST:
    case IAuthActionTypes.VERIFY_OTP_REQUEST:
      return {
        ...state,
        is_in_api_call: true,
        otperrormessage: "",
      };

    case IAuthActionTypes.OTP_FAILURE:
      return {
        ...state,
        otperrormessage: payload.otperrormessage,
        is_in_api_call: false,
      };
    case IAuthActionTypes.OTP_SUCCESS:
      return {
        ...state,
        verifytoken: payload.auth_token,
        currentuserinfo: normalizeAccessLevel({
          id: payload.user_id,
          name: payload.user_name,
          entity_id: {
            id: payload.entity_id,
          },
          access_level: payload.access_level,
        }),
        isotpreceived: true,
        otperrormessage: "",
        is_in_api_call: false,
      };
    case IAuthActionTypes.OTP_CANCEL:
      return {
        ...state,
        isotpverified: false,
        isotpreceived: false,
        otperrormessage: "",
        is_fr_verification_in_progress: false,
        frError: "",
        is_in_api_call: false,
      };

    case IAuthActionTypes.VERIFY_OTP_SUCCESS:
      return {
        ...state,
        authtoken: payload.auth_token,
        isuserLogin: payload?.isuserLogin ? true : false,

        currentuserinfo: normalizeAccessLevel({
          ...state?.currentuserinfo,
          ...payload,
        }),

        isotpverified: true,
        otperrormessage: "",
        is_fr_verification_in_progress: true,
        is_in_api_call: false,
      };

    case IAuthActionTypes.VERIFY_OTP_FAILURE:
      return {
        ...state,
        isotpverified: false,
        // otperrormessage: payload?.otperrormessage || "",
        otperrormessage: "",
        is_in_api_call: false,
      };

    case IAuthActionTypes.FETCH_CURRENT_USER_SUCCESS:
      return {
        ...state,
        isuserlogin: true,
        authtoken: localStorage.getItem("auth_token"),
        isuserLogin: !!localStorage.getItem("auth_token"),
        currentuserinfo: normalizeAccessLevel({
          ...state.currentuserinfo,
          ...payload,
        }),
      };
    case IAuthActionTypes.LOGOUT:
      return {
        ...state,
        user: null,
        isotpverified: false,
        isotpreceived: false,
      };
    case IAuthActionTypes.SILENT_LOGIN:
      return {
        ...state,
      };

    case IAuthActionTypes.LOGIN_FR_VERIFY_SUCCESS:
      return {
        ...state,
        isFRVerified: true,
        authtoken: payload.auth_token,
        isuserLogin: true,
        currentuserinfo: normalizeAccessLevel({
          ...state.currentuserinfo,
          ...payload,
        }),
        isotpverified: true,
        otperrormessage: "",
        is_fr_verification_in_progress: false,
        frError: "",
        is_in_api_call: false,
      };

    case IAuthActionTypes.LOGIN_FR_VERIFY_FAILURE:
      return {
        ...state,
        isFRVerified: false,
        isuserLogin: false,
        is_fr_verification_in_progress: true,
        frError: payload?.error,
        is_in_api_call: false,
      };

    case IAuthActionTypes.LOGIN_FR_VERIFY_REQUEST:
      return {
        ...state,
        isFRVerified: false,
        isuserLogin: false,
        is_fr_verification_in_progress: true,
        frError: "",
        is_in_api_call: true,
      };

    default:
      return state;
  }
};

export default reducer;
